import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useUserContext } from '../../context/user_context/UserContext';
import { useNavigate } from 'react-router-dom';
import Logo from '../../resources/images/logo/bizismart.png';
import { useTheme as appTheme } from '../../context/theme_context/ThemeContext';
import { CssBaseline, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Modules } from '../../utils/permissions/Modules';
import { PermissionTypes } from '../../utils/permissions/PermissionTypes';
import usePermissions from '../../utils/permissions/UsePermissions';
import { useSignOutContext } from '../../context/sign_out_context/SignOutContext';
import { StringKeys } from '../../resources/strings/StringKeys';
import { BugReport, DarkMode, LightMode, PowerSettingsNew, Wallet } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

function BaseNavBar({content}) {
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showBugModal, setShowBugModal] = useState(false);
  const { clearAndSignOut } = useSignOutContext()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const { firebaseUser } = useUserContext();
  const { toggleTheme, themeMode, toggleThemeNoFirebaseUpdate } = appTheme();
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();
  const { t } = useTranslation()

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const toggleDrawer = (open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  const handleSignOut = () => {
    console.log("[BaseNavBar] Starting sign out process");
    handleCloseUserMenu();
    toggleThemeNoFirebaseUpdate();
    // Clear and sign out, then navigate to root
    clearAndSignOut(navigate);
  };

  return (
    <>
        <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="fixed" style={{ background: 'black' }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
          {isDesktop && (
              <img
                alt="BiziSmart"
                src={Logo}
                width="30"
                height="30"
                onClick={() => navigate('/')}
                style={{ cursor: 'pointer', marginRight:"10px" }}
              />
            )}
            {!isDesktop && (
              <Box>
                <img
                  alt="BiziSmart"
                  src={Logo}
                  width="30"
                  height="30"
                  style={{ cursor: 'pointer' }}
                  onClick={() => navigate('/')}

                />
              </Box>
            )}

            <Typography
              variant="h6"
              sx={{ display: { xs: 'none', md: 'flex' }, fontWeight: 700, letterSpacing: '.3rem', color: 'inherit', cursor: 'pointer' }}
              onClick={() => navigate('/')}
            >
              BiziSmart
            </Typography>

            <Box sx={{ flexGrow: 0 }}>

              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <MenuItem
                  key="theme"
                  onClick={() => {
                    toggleTheme(firebaseUser.uid);
                    handleCloseUserMenu();
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {themeMode === 'light' ? <LightMode /> : <DarkMode />}
                    <Typography sx={{ ml: 1, textAlign: 'center' }}>
                      {' '}
                      {themeMode === 'light' ? t(StringKeys.LIGHT_MODE) : t(StringKeys.DARK_MODE)}
                    </Typography>
                  </Box>
                </MenuItem>
                {hasPermission(Modules.SUBSCRIPTION, PermissionTypes.READ) && (
                  <MenuItem
                    key="subscription"
                    onClick={() => {
                      handleCloseUserMenu();
                      navigate('/subscription');
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Wallet /> {' '}
                      <Typography sx={{ ml: 1, textAlign: 'center' }}>{t(StringKeys.SUBSCRIPTION)}</Typography>
                    </Box>
                  </MenuItem>
                )}
                <MenuItem
                  key="bug"
                  onClick={() => {
                    setShowBugModal(true);
                    handleCloseUserMenu();
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                   <BugReport/> {' '}
                    <Typography sx={{ ml: 1, textAlign: 'center' }}>{t(StringKeys.REPORT_A_BUG)}</Typography>
                  </Box>
                </MenuItem>
                <MenuItem
                  key="logout"
                  onClick={handleSignOut}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <PowerSettingsNew /> {' '}
                    <Typography sx={{ ml: 1, textAlign: 'center' }}>{t(StringKeys.LOG_OUT)}</Typography>
                  </Box>
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      </Box>
      <Box component="main" sx={{ flexGrow: 1, pt: 3, marginTop: '60px' }}>
        {content}
      </Box>
    </>
  );
}

export default BaseNavBar;